import React from 'react';

import {
    Box,
    Button,
    HStack,
    Link,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    useTheme
} from '@chakra-ui/react';
import { noop } from '@chakra-ui/utils';
import { FormattedMessage } from 'react-intl';

import { getV2Url } from '~/lib/utils/booking';

const UserMembershipNotPaidModal = () => {
    const { logoSmall } = useTheme();

    return (
        <Modal isOpen onClose={noop} size="lg" colorScheme="blue">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader />
                <ModalBody>
                    <Box className="membership-not-paid-modal">
                        <Box className="logo-container">
                            <img src={logoSmall} alt="logo" />
                        </Box>
                        <Box className="title" mb="8">
                            <FormattedMessage
                                id="user.membership_not_paid.modal_title"
                                defaultMessage="Die Zahlung für die Verlängerung der Mitgliedschaft ist ausstehend und wurde angemahnt. Die Nutzunt der Mitgliedschaftsvorteile sowie die Buchung von und Teilnahme an Kursen ist wieder möglich, sobald der ausstehende Rechnungsbetrag beglichen wurde."
                            />
                        </Box>
                        <HStack pt="2">
                            <Link href={getV2Url('/user/dashboard/membership')} className="button">
                                <Button colorScheme="blue">
                                    <FormattedMessage
                                        id="user.go-to-dashboard"
                                        defaultMessage="Zum Kundenkonto"
                                    />
                                </Button>
                            </Link>
                        </HStack>
                    </Box>
                </ModalBody>
                <ModalFooter />
            </ModalContent>
        </Modal>
    );
};

export default UserMembershipNotPaidModal;
